var path = 'app/components/stavkaNaloga/vrstaRada.html';
var html = "<h2>Vrsta rada</h2><hr><div id=\"vrste-rada\" class=\"panel-body float-e-margins\"><div class=\"row\"><div class=\"col-lg-2\" ng-repeat=\"grupa in vm.grupe\"><h4 class=\"m-t-sm m-b-sm\">{{grupa.naziv}}</h4><div ng-repeat=\"row in grupa.items\"><span class=\"vrsta\" ng-repeat=\"item in row\"><a ng-click=\"vm.click(item)\" class=\"btn btn-primary\" ng-class=\"{'btn-warning': vm.itemSelected(item)}\" type=\"button\">{{item.naziv}}</a></span></div></div></div></div><hr>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/stavkaNaloga/vrstaRada.html
// module id = 606
// module chunks = 0